

























import { Component, Vue } from "vue-property-decorator";
import { RegistrationInformation, User } from "../types";
import { postNewUser } from "../helpers/user-getter";
import router from "../router";

@Component
export default class EditPassword extends Vue {
  user: RegistrationInformation = {
    email: "",
    username: "",
    password: "",
  };

  error = "";

  createNewUser() {
    postNewUser(this.user)
      .then((response) => {
        sessionStorage.setItem("token", response.token);
        this.$store.dispatch("setUser", {
          id: response.user.id,
          username: this.user.username,
          email: this.user.email,
          admin: response.user.admin,
        });

        router.replace("/");

        this.user.email = "";
        this.user.username = "";
        this.user.password = "";

        this.error = "";
      })
      .catch((err) => {
        this.error = err.message;
      });
  }
}
